import { ConnectionType } from '../../api/connections.dao';
import { FormVmItemConfigType } from '../../infrastructure/form-viewmodel-controller';
import { plainText } from '../validators';
import _config, { ConnectionFields } from './config';

export const configOverrides = {
    [ConnectionType.Other]: {
        [ConnectionFields.CONNECTION_ID]: { validators: [ plainText.maxLength.short ] }
    },
    [ConnectionType.Veracast]: {
        [ConnectionFields.CONNECTION_LINK]: { label: 'Veracast Event URL' }
    }
};

export const getConfigKeys = (type: ConnectionType | void): ConnectionFields[] => {
    switch (type) {
        case ConnectionType.Other:
            const configKeys = [ConnectionFields.PASSPORT_REPLAY,ConnectionFields.NAME].concat(getConfigKeys());
            const idx = configKeys.findIndex(key => key === ConnectionFields.LABEL);
            if (!(idx === -1)) configKeys.splice(idx, 1);

            return configKeys;
        case ConnectionType.InPerson:
            return [
                ConnectionFields.NAME,
                ConnectionFields.MEETING_LOCATION,
                ConnectionFields.CONNECTION_NOTES
            ];

        case ConnectionType.Knovio:
            return [
                ConnectionFields.PASSPORT_REPLAY,
                ConnectionFields.PUBLISH_CONNECTION,
                ConnectionFields.DETAILS_PLACEHOLDER_TEXT,
                ConnectionFields.KNOVIO_ACCOUNT_NAME,
                ConnectionFields.KNOVIO_NAME,
                ConnectionFields.EMBED_CODE_ID,
                ConnectionFields.PODIUM_LINK,
                ConnectionFields.PODIUM_ACCESS_CODE,
                ConnectionFields.PODIUM_EMBED_CODE,
                ConnectionFields.LIVE_STREAM_ENABLED,
                ConnectionFields.PRIMARY_LIVE_STREAM_URL,
                ConnectionFields.PRIMARY_LIVE_STREAM_NAME,
                ConnectionFields.BACKUP_LIVE_STREAM_URL,
                ConnectionFields.BACKUP_LIVE_STREAM_NAME,
                ConnectionFields.CONNECTION_NOTES
            ];

        case ConnectionType.Showcase:
            return [
                ConnectionFields.SHOWCASE_PAGE_PATH,
                ConnectionFields.SHOWCASE_NAME,
                ConnectionFields.KNOVIO_ACCOUNT_NAME
            ];
        case ConnectionType.Webinar:
            return [
                ConnectionFields.LABEL,
                ConnectionFields.MEETING_UNIQUE_REFERENCE,
                ConnectionFields.CONNECTION_LINK,
                ConnectionFields.REGISTRATION_LINK,
                ConnectionFields.ALTERNATIVE_LINK,
                ConnectionFields.HOST_LINK,
                ConnectionFields.CONNECTION_ID,
                ConnectionFields.AUTOMATICALLY_RECORD,
                ConnectionFields.AUTO_REGISTRATION_ENABLED,
                ConnectionFields.SYNC_MEETING_ATTENDEE_WITH_ZOOM_ENABLED,
                ConnectionFields.REGISTRATION_ENABLED,
                ConnectionFields.AUTOMATICALLY_APPROVAL,
                ConnectionFields.REGISTRATION_CONFIRMATION_EMAIL,
                ConnectionFields.CONNECTION_PASSWORD,
                ConnectionFields.CONNECTION_ACCOUNT,
                ConnectionFields.SIP,
                ConnectionFields.CONNECTION_HOST_KEY,
                ConnectionFields.DIAL_FOR_VS,
                ConnectionFields.CONNECTION_TOPIC,
                ConnectionFields.MEETING_INVITATION,
                ConnectionFields.CONNECTION_NOTES,
                ConnectionFields.ZOOM_DESCRIPTION
            ];
        case ConnectionType.UniqueJoiningLink:
            return [
                ConnectionFields.ATTENDEE_EMAIL,
                ConnectionFields.CONNECTION_LINK,
                ConnectionFields.ALTERNATIVE_LINK,
                ConnectionFields.CONNECTION_ID,
                ConnectionFields.CONNECTION_PASSWORD,
                ConnectionFields.MEETING_INVITATION,
                ConnectionFields.ZOOM_DESCRIPTION
            ];
        case ConnectionType.Veracast:
            return [
                ConnectionFields.VERACAST_EVENT_ID,
                ConnectionFields.VERACAST_CONF_ID,
                ConnectionFields.CONNECTION_LINK,
                ConnectionFields.CONNECTION_PASSWORD,
                ConnectionFields.CLIENT_APP_LINK
            ];
        // REGULAR CONNECTIONS
        case ConnectionType.Zoom:
            const additionalZoomFieldsNames = [
                ConnectionFields.AUTO_REGISTRATION_ENABLED,
                ConnectionFields.SYNC_MEETING_ATTENDEE_WITH_ZOOM_ENABLED,
                ConnectionFields.REGISTRATION_ENABLED,
                ConnectionFields.AUTOMATICALLY_APPROVAL,
                ConnectionFields.REGISTRATION_CONFIRMATION_EMAIL
            ];
            const connectionZoomFields = getConfigKeys();
            const connectionZoomIdFieldIndex = connectionZoomFields.findIndex(field => field === ConnectionFields.CONNECTION_ID);
            connectionZoomFields.splice(connectionZoomIdFieldIndex + 1, 0, ...additionalZoomFieldsNames);
            return connectionZoomFields;
        case ConnectionType.Webex:
        case ConnectionType.Bluejeans:
        case ConnectionType.Teams:
            default:
                return [
                ConnectionFields.LABEL,
                ConnectionFields.MEETING_UNIQUE_REFERENCE,
                ConnectionFields.CONNECTION_LINK,
                ConnectionFields.ALTERNATIVE_LINK,
                ConnectionFields.HOST_LINK,
                ConnectionFields.CONNECTION_ID,
                ConnectionFields.CONNECTION_PASSWORD,
                ConnectionFields.CONNECTION_ACCOUNT,
                ConnectionFields.SIP,
                ConnectionFields.CONNECTION_HOST_KEY,
                ConnectionFields.DIAL_FOR_VS,
                ConnectionFields.CONNECTION_TOPIC,
                ConnectionFields.MEETING_INVITATION,
                ConnectionFields.CONNECTION_NOTES
            ];
    }
};

export const getConfigItemByKey = (key: string, cnf = _config): FormVmItemConfigType => cnf?.[key] ?? {};

export default new Proxy(_config, {
    get: (cnf, type: ConnectionType) =>
        getConfigKeys(type)
            .map(key => ({
                name: key,
                ...getConfigItemByKey(key, _config),
                ...getConfigItemByKey(key, configOverrides?.[type] ?? {}),
            }))
});
